import { signout } from '@bigyellow/components/Signout'
import { withStore } from '@bigyellow/store'
import { useEffect } from 'react'
import { getItem, removeItem } from '@bigyellow/libs/storage'

function Logout({ store }) {


     useEffect(() => {
       if(!store) return;
       const notify = store.get('notify');

       getItem('flashmessage').then(res => {
            if (typeof res?.message == 'undefined') return;

            const { message, type } = res;

            removeItem('flashmessage').then(() => {

                if (notify) notify(message, { type: type });
            });
        });
        signout(store);
    }, [store]);

    return '';
}

export default withStore(Logout);